import { render } from "./ChartE.vue?vue&type=template&id=f07f7246"
import script from "./ChartE.vue?vue&type=script&lang=ts"
export * from "./ChartE.vue?vue&type=script&lang=ts"
script.render = render

export default script